import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useStore } from "../../store";
import DamageService from "../../services/DamageService";
import useStore2 from "../../store/hook";
import ProcessingScreen from "../../components/ProcessingScreen";

const STAGES = [
  "Зургийг уншиж байна",
  "Машины эд ангиудыг тодорхойлж байна",
  "Гэмтлийг илрүүлж байна",
  "Дүнг бэлтгэж байна",
];

const Progress = () => {
  const navigate = useNavigate();

  const setZuragu = useStore2.useSetZuragu();
  const setTokenData = useStore.useSetTokenData();
  const createDate = useStore2.useCreateDate();
  const vehicleInfo = useStore2.useVehicleInfo();
  const name = useStore2.useName();

  const [complete, setComplete] = useState(false);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    DamageService.submitDamage(name).then((response) => {
      if (!response) {
        setFailed(true);
        return;
      }
      setZuragu(response);
      setTokenData({
        plate_number: vehicleInfo?.plateNumber || "",
        vin: vehicleInfo?.vin || "",
        make_id: [0, vehicleInfo?.make || ""],
        model_id: [0, vehicleInfo?.model || ""],
      });
      setComplete(true);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    createDate,
    name,
    setZuragu,
    setTokenData,
    vehicleInfo?.make,
    vehicleInfo?.model,
    vehicleInfo?.plateNumber,
    vehicleInfo?.vin,
  ]);

  useEffect(() => {
    if (failed) navigate("/damages");
  }, [failed, navigate]);

  const handleDone = useCallback(() => navigate("/result"), [navigate]);

  return (
    <ProcessingScreen
      stages={STAGES}
      complete={complete}
      onDone={handleDone}
      media={
        <div className="relative overflow-hidden rounded-2xl">
          <img src="/sample-pics/simple.png" alt="vehicle-pic" className="max-h-[38vh]" />
          <div className="scan-progress" />
        </div>
      }
    />
  );
};

export default Progress;
